'use strict';

var SessionStorageStateSource = require('./sessionStorage');
var registerStateSource = require('../core/registerStateSource');

module.exports = function (marty) {
  registerStateSource(marty, 'SessionStorageStateSource', 'sessionStorage', SessionStorageStateSource);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty-lib/modules/session-storage-state-source/index.js
 ** module id = 579
 ** module chunks = 0
 **/